import { receiveUpdateCallWidgetTriggerType } from 'flow/actions/run-url-actions';
import Page from 'flow/components/Setting/Page';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import { CallwidgetKey } from 'flow/types/EntityKeys';
import { CallwidgetParams } from 'flow/types/Params';
import { routes } from 'flow/types/routes';

import { TriggerTypes } from 'flow/utils';
import { generatePath } from 'flow/utils/router-utils';
import { useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useHistory, useParams } from 'react-router-dom';

const CallWidgetTriggerType = () => {
    const { i18next } = useAppContext();
    const history = useHistory();
    const dispatch = useAppDispatch();
    const { extensionKey, callwidgetKey } = useParams<CallwidgetParams>();
    const triggerType = useAppSelector((state) =>
        state.callWidgets?.getIn([callwidgetKey, 'triggerType']),
    );
    const [selectedTriggerType, setSelectedTriggerType] = useState(triggerType);

    const handleUpdate = (
        callWidgetKey: CallwidgetKey,
        option: typeof TriggerTypes,
    ) => {
        setSelectedTriggerType(option.key);
        dispatch(receiveUpdateCallWidgetTriggerType(callWidgetKey, option.key));
    };

    return (
        <Page
            header={i18next.t('settings.callrouting.call_widgets.trigger_type')}
            onClickBack={() =>
                history.push(
                    generatePath(
                        routes[
                            'settings.softphone.advanced.callwidgets.callwidgetKey'
                        ],
                        { extensionKey, callwidgetKey: callwidgetKey },
                    ),
                )
            }
        >
            {TriggerTypes.enums.map((option: typeof TriggerTypes) => (
                <RadioButton
                    name={`languageEnumItem-option-${option.key}`}
                    checked={option.key === selectedTriggerType}
                    onChange={() => handleUpdate(callwidgetKey, option)}
                >
                    {i18next.t(
                        `settings.callrouting.call_widgets.trigger_type.${option.key}`,
                    )}
                </RadioButton>
            ))}
        </Page>
    );
};

export default CallWidgetTriggerType;
